import { Button, ICON_COLOR } from '@zep-us/zus';
import { PlayIcon, SquareStackIcon } from '@zep-us/zus-icons';
import { useTranslation } from 'next-i18next';

/**
 * MobileViewerCTAButtons Props
 */
export interface MobileViewerCTAButtonsProps {
  /** 복사 버튼 클릭 핸들러 */
  onDuplicate: () => void;
  /** 입장 버튼 클릭 핸들러 */
  onEnter: () => void;
}

/**
 * MobileViewerCTAButtons - 모바일용 뷰어 CTA 버튼
 *
 * @description
 * 모바일 하단 고정 영역에 최적화된 뷰어용 CTA 입니다.
 * 폭을 나눠 갖는 텍스트 버튼 둘(복사·입장) 오른쪽에, 폭이 고정된 폴더 저장
 * 아이콘 버튼이 붙는다.
 *
 * @example
 * ```tsx
 * <MobileViewerCTAButtons
 *   onDuplicate={handleDuplicate}
 *   onEnter={handleEnter}
 * />
 * ```
 */
export const MobileViewerCTAButtons = ({
  onDuplicate,
  onEnter
}: MobileViewerCTAButtonsProps) => {
  const {
    t
  } = useTranslation(['common']);
  return <div className="flex w-full gap-sm" data-sentry-component="MobileViewerCTAButtons" data-sentry-source-file="MobileViewerCTAButtons.tsx">
      <Button size="md" intent="gradient" variant="contained" leftSlot={<SquareStackIcon size="sm" fill={ICON_COLOR.inverse} />} onClick={onDuplicate} className="flex-1" data-sentry-element="Button" data-sentry-source-file="MobileViewerCTAButtons.tsx">
        {t('common:detail.saveToMyQuiz')}
      </Button>
      <Button size="md" variant="contained" intent="alternative" onClick={onEnter} leftSlot={<PlayIcon size="sm" fill={ICON_COLOR.strong} />} className="flex-1" data-sentry-element="Button" data-sentry-source-file="MobileViewerCTAButtons.tsx">
        {t('detail.cta.tutorial')}
      </Button>
    </div>;
};